import { RefObject, useEffect } from 'react';

export type OutSideType = MouseEvent | KeyboardEvent | TouchEvent;

export const useOnClickOutside = <T extends HTMLElement = HTMLElement>(
  ref: RefObject<T>,
  handler: (event: OutSideType) => void,
) => {
  useEffect(() => {
    const listener = (event: OutSideType) => {
      if (!ref.current || ref.current.contains(event.target as Node)) {
        return;
      }
      handler(event);
    };
    document.addEventListener('mousedown', listener);
    document.addEventListener('keydown', listener);
    document.addEventListener('touchstart', listener);
    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('keydown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
};
